export default __webpack_public_path__ + "static/media/Alesha_Brown_AHV_In_Moms_We_Trust.f078579e.jpg";